module.exports = __webpack_public_path__ + "static/media/save_to_template.87f62eb2.png";